const USER_PREF_PRESETS_CLIENT_CUSTOM = {
};

export default USER_PREF_PRESETS_CLIENT_CUSTOM;
